import type { ChartOptions } from 'chart.js';

function cssVar(name: string, fallback: string): string {
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return value || fallback;
}

export function getChartColors() {
  return {
    primary: cssVar('--chart-primary', '#378ADD'),
    success: cssVar('--chart-success', '#1D9E75'),
    warning: cssVar('--chart-warning', '#E24B4A'),
    channels: [
      cssVar('--chart-channel-0', '#378ADD'),
      cssVar('--chart-channel-1', '#1D9E75'),
      cssVar('--chart-channel-2', '#7F77DD'),
      cssVar('--chart-channel-3', '#BA7517'),
    ] as const,
  };
}

/** @deprecated Use getChartColors() so colors follow the active theme */
export const CHART_COLORS = {
  primary: '#378ADD',
  success: '#1D9E75',
  warning: '#E24B4A',
  channels: ['#378ADD', '#1D9E75', '#7F77DD', '#BA7517'] as const,
};

export function chartGridColor(): string {
  return cssVar('--chart-grid', 'rgba(0, 0, 0, 0.06)');
}

export function chartTextColor(): string {
  return cssVar('--chart-text', '#64748b');
}

export function lineChartOptions(): ChartOptions<'line'> {
  return baseChartOptions() as ChartOptions<'line'>;
}

export function barChartOptions(): ChartOptions<'bar'> {
  return baseChartOptions() as ChartOptions<'bar'>;
}

export function baseChartOptions(): ChartOptions<'line' | 'bar' | 'doughnut'> {
  const grid = chartGridColor();
  const text = chartTextColor();
  return {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: { color: text },
      },
    },
    scales: {
      x: {
        ticks: { color: text },
        grid: { color: grid },
      },
      y: {
        ticks: { color: text },
        grid: { color: grid },
        beginAtZero: true,
      },
    },
  };
}

export function doughnutChartOptions(): ChartOptions<'doughnut'> {
  return {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right',
        labels: { color: chartTextColor() },
      },
    },
  };
}

export function horizontalBarOptions(): ChartOptions<'bar'> {
  const base = baseChartOptions() as ChartOptions<'bar'>;
  return {
    ...base,
    indexAxis: 'y',
    scales: {
      x: {
        ticks: { color: chartTextColor() },
        grid: { color: chartGridColor() },
        beginAtZero: true,
      },
      y: {
        ticks: { color: chartTextColor() },
        grid: { display: false },
      },
    },
  };
}
